export default {
    setToken(state, value) {
        if (value) {
            state.token = value
            sessionStorage.setItem('token', value)
        } else {
            state.token = null
            sessionStorage.removeItem('token')
        }
    },
    setEnterprise(state, value) {
        state.enterpriseInfo = value
        sessionStorage.setItem('enterpriseInfo', JSON.stringify(value))
    },
    setUser(state, value) {
        state.userInfo = value
        sessionStorage.setItem('userInfo', JSON.stringify(value))
    }
}
